import { Carousel } from '3d-react-carousal';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import curveBorder from '../../assets/underline.svg';
import { ImLocation } from 'react-icons/im';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TopPlaces = () => {

    const [places, setPlaces] = useState([]);
    useEffect(() => {
        fetch('./topPlaces.json')
            .then(res => res.json())
            .then(data => setPlaces(data))
    }, []);

    var settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        fade: true,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    return (
        <div className='my-32 w-11/12 mx-auto'>
            <div className='flex flex-col items-center'>
                <h1 className='text-4xl font-bold text-center'>Trending Places</h1>
                <img className='block w-40' src={curveBorder} alt="curve underline" />
            </div>
            <p className='text-center'>Explore top trending places to visit in this season...</p>
            <div className='my-12'>
                <div className='lg:flex justify-even items-center'>
                    <div className='md:w-2/3 md:mx-auto lg:w-2/5'>
                        <Carousel className='rounded-lg' slides={
                            places?.map(place =>
                                <img src={place.img} className='rounded-lg' alt="1" />
                            )
                        } autoplay={true} arrows={false} interval={3000} />
                    </div>
                    <div className='lg:w-2/5 my-4'>
                        <Slider {...settings} >
                            {
                                places?.map(place =>
                                    <div key={place.id} className={place.id === 0 ? `carousel-item active float-left w-full` : `carousel-item float-left w-full`} data-bs-interval="3000">
                                        <h1 className='text-3xl font-semibold text-yellow-500'>{place.name}</h1>
                                        <div className='my-4 flex items-center text-gray-500'>
                                            <ImLocation />
                                            <p className='ml-1 font-semibold'>{place.location}</p>
                                        </div>
                                        <p><span className='font-semibold text-yellow-500'>Description : </span>{place.text}</p>
                                    </div>
                                )
                            }
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopPlaces;